<template>
  <div>
    <GeoLocation />
    <section>
      <div class="container">
        <h3>Register Your RUX</h3>
        <p class="push-down-20">Thanks for choosing our {{ placeholder }} RUX</p>
        <div class="row">
          <form @submit="submit">
            <div class="form-group">
              <label for="shortDescription"
                >Enter a short description for your new RUX.<br> Eg:
                Winter Outerwear, or leave it blank and we'll
                add it for you.</label
              >
              <input
                class="form-control"
                v-model="rux.shortDescription"
                type="text"
                :placeholder="placeholder"
              />
            </div>

            <div class="label-wrapper push-down-20">
              <label class="sign-up" for="check">Sign me up for deals from RUX </label>
              <input
                id="check"
                class="checkbox col-2 pointer"
                type="checkbox"
                label=""
                v-model="signUp"
                data-testid="checkbox"
              />
            </div>
            <div class="push-down-20">
              <button class="pointer" v-if="showRegisterButton">Register</button>
              <div v-if="showAlreadyRegistered">
                <p>It looks like this RUX is already registered</p>
                <p>
                  <a href="https://instagram.com/rux.life"
                    >If this is an error please contact our support team
                    @rux.life on Instagram</a
                  >
                </p>
              </div>
              <div v-if="showNoSerialNumber">
                No Serial Number Present, please rescan your RUX!
              </div>
              <div class="loader-wrapper push-down-20">
                <loading
                  color="rgb(187, 57, 54)"
                  :active.sync="showLoading"
                  :is-full-page="false"
                  loader="bars"
                ></loading>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ConfirmDialog></ConfirmDialog>
    </section>
  </div>
</template>
<script>
// This component takes care of registering the product for the user.
import Loading from 'vue-loading-overlay'
import GeoLocation from './GeoLocation'
import { rux } from './../../lib/rux.js'
import ConfirmDialog from './ConfirmDialog/vue-confirm-dialog'

export default {
  name: 'RegisterProduct',
  components: { Loading, GeoLocation, ConfirmDialog },
  computed: {
    placeholder: function () {
      return this.rux.size + ' ' + this.rux.color.toLowerCase() + ' colorway'
    },
  },
  data: () => {
    return {
      showRegisterButton: true,
      showLoading: false,
      showAlreadyRegistered: false,
      showNoSerialNumber: false,
      signUp: false,
      hasReferralLink: false,
      // The data model
      rux: {
        shortDescription: '',
        serialNumber: '',
        size: '',
        color: '',
      },
    }
  },
  methods: {
    addRux: async function () {
      this.showRegisterButton = false
      this.showLoading = true
      if (this.rux.shortDescription === '')
        this.rux.shortDescription = this.placeholder
      // Set the serial number here
      this.rux.serialNumber = this.$store.state.rux.register.serialNumber

      // Send it to the store to add to the DB
      // On success the store will redirect to post a post registration form
      await this.$store.dispatch('rux/addRux', this.rux)
      if (this.signUp) {
        await rux.addEmailToMarketingStore()
      }
      // These only get hit when there is an error.
      this.showLoading = false
      this.showRegisterButton = true
    },
    submit: async function (e) {
      // Dont actually submit the form
      e.preventDefault()
      if (this.$store.state.rux.register.forcePin) {
        this.openPinDialog(
          'Please enter the pin number found on the back of the RUX card'
        )
      } else {
        this.addRux()
      }
    },
    openPinDialog: async function (message) {
      this.$confirm({
        auth: true,
        message,
        buttons: [
          {
            // Do nothing on cancel
            text: 'Cancel',
            forceCancelOnAuth: true,
          },
          {
            text: 'Submit',
            callback: async (pin) => {
              this.$store
                .dispatch('rux/validatePinCode', {
                  pin,
                })
                .then((result) => {
                  if (!result.data) {
                    this.openPinDialog(
                      'There was an error with the pin code entered. Please double check the 4 digits on the back of the RUX card.'
                    )
                  } else {
                    this.addRux()
                  }
                })
            },
          },
        ],
        onCancelCallback: () => {},
        parent: this._uid,
      })
    },
  },
  async mounted() {
    if (this.$store.state.rux.register.serialNumber) {
      let alreadyRegistered = await rux.checkRuxExistsInGlobalList(
        this.$store.state.rux.register.serialNumber
      )
      this.rux.size = this.$store.state.rux.register.serialNumber.split('-')[1]
      this.rux.color = this.$store.state.rux.register.serialNumber.split('-')[3]
      if (alreadyRegistered) {
        this.showRegisterButton = false
        this.showAlreadyRegistered = true
      }
    } else {
      this.showRegisterButton = false
      this.showNoSerialNumber = true
    }
  },
}
</script>
<style lang='scss' scoped>
h3 {
  margin-top: 40px;
  font-family: "Neue Medium";
  font-size: 30px;
  font-weight: 200px;
}

p {
  font-family: "Neue Roman";
  font-size: 18px;
}
.loader-wrapper {
  position: relative;
  height: 40px;
}
input.checkbox {
  box-shadow: none;
  outline: none;
  border: none;
}

form {
  padding: 0px 20px;
  margin: 10px auto;
  line-height: 2em;
  font-family: "Neue Roman";
  font-size: 17px;
  label {
    text-align: center;
    width: 100%;
  }
  input[type='text'],
  textarea {
    padding: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
    background-color: white;
    border: none;
    text-transform: capitalize;
    height: 50px;
    font-size: 17px;
  }
  label.serialNumber {
    padding: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  input[type='checkbox'] {
    width: 20px;
    height: 20px;
  }
  .readonly {
    color: #adadad;
    cursor: not-allowed;
  }
  label.sign-up {
    width: 65%;
    padding-top: 2px;
  }
  label {
    margin-bottom: 0rem;
  }
  .push-down {
    margin-top: 10px;
  }
  .label-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
